import Dialog from "../../atoms/dialog";
import { Button, Typography, Box } from "@material-ui/core";
import { useState, useEffect, Fragment } from 'react';
import { useSelector } from 'react-redux';
import { getApiResponseCode, getApiResponseMessage } from '../../../store/global/selectors';
import { invokeGetService, setApiResponseCode, setApiResponseMessage } from '../../../store/global/actions';
import { useHistory } from 'react-router-dom'
import { useDispatch } from 'react-redux'
import { getDetailsFromUrl } from "../../../services/blueprint";


export function ApiResponseAlert() {

    const [open, setOpen] = useState(false)
    const [title, setTitle] = useState('Access alert!')
    const responseCode = useSelector(getApiResponseCode)
    const responseMessage = useSelector(getApiResponseMessage)
    const [isLoading, setLoading] = useState(false)
    const history = useHistory()
    const dispatch = useDispatch()
    const { slug, screen, blueprintId, entityId } = getDetailsFromUrl();

    const buttonTexts = {
        251: 'Back to dashboard',
        252: 'Back to dashboard',
    }
    useEffect(() => {
        setOpen([251, 252, 253, 254, 255, 257].includes(responseCode))
    }, [responseCode])

    const onClose = () => {
        if (buttonTexts[responseCode] === undefined) {
            setOpen(false)
        } else {
            setOpen(true)
        }
    }

    const onButtonClose = async() => {
        if (responseCode == 251 || responseCode == 252) {
            dispatch(setApiResponseCode(0))
            dispatch(setApiResponseMessage(''))
            history.push('/')
        } else if (responseCode == 257) {
            dispatch(setApiResponseCode(0))
            dispatch(setApiResponseMessage(''))
            history.push(`/blueprint/${slug}/${blueprintId}/system-model`);
        } else {    
            setLoading(true)
            if(screen === 'testsuite'){
                const response = await dispatch(invokeGetService('findActiveTestcase',[entityId]))
                const {testsuiteId, testcaseId} = response?.data
                if(!testsuiteId){
                    history.push(`/blueprint/${slug}/${blueprintId}/system-model`);
                }else{
                    history.push({
                        pathname: `/blueprint/${slug}/${blueprintId}/testsuite/${testsuiteId}`,
                        search: testcaseId ? `?testcase=${testcaseId}` : ''
                    })
                }
            }
            setLoading(false)
            dispatch(setApiResponseCode(0))
            dispatch(setApiResponseMessage(''))
        }
    }

    const Actions = () => {
        return <Button color={'primary'} onClick={onButtonClose} variant={'contained'}>{buttonTexts[responseCode] ? buttonTexts[responseCode] : isLoading ? 'Loading...' : 'Okay'}</Button>
    }

    return (
        <Dialog
            title={title}
            open={open}
            handleClose={onClose}
            actions={<Actions />}
        >
            {
                <Typography>{responseMessage}</Typography>
            }
            {/* { responseCode != 0 && <Typography>{responseCode}</Typography>} */}

        </Dialog >
    )
}